export default __webpack_public_path__ + "static/media/loading.489f0ad0.gif";